module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pais/pais.component.css
// module id = ./src/app/pais/pais.component.css
// module chunks = main